export const EstadoSolicituPersonal = {
    PENDIENTE:"PENDIENTE",
    INICIADO:"INICIADO",
    RECHAZADO:"RECHAZADO",
    CERRADO: "CERRADO",
    CANCELADO:"CANCELADO",
}